import * as React from 'react'
import {useId} from 'react'

import Contents from '../components/common/Contents/Contents'

export const BuildSelectionIdContext = React.createContext<string>('')
type BuildSelectionProviderProps = {
  children?: React.ReactNode
}
export function BuildSelectionIdProvider({children}: BuildSelectionProviderProps) {
  const id = useId()
  return (
    <BuildSelectionIdContext.Provider value={id}>
      <Contents data-selection-parent>{children}</Contents>
    </BuildSelectionIdContext.Provider>
  )
}
